var _style, _path, _path2, _path3, _style2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      height: 200
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0 fCYXbxDN_0",
    width: 24,
    height: 42,
    d: "M24.5 39.2 L48.5 39.2 L48.5 81.2 L24.5 81.2 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0 fCYXbxDN_1",
    d: "M3,29.5L117,94.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0 fCYXbxDN_2",
    d: "M56.3,82.7L95.3,106.2L95.3,13.8L56,37.5"
  })), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", null, ".fCYXbxDN_0{stroke-dasharray:132 134;stroke-dashoffset:133;animation:fCYXbxDN_draw 2980ms linear 0ms forwards;}.fCYXbxDN_1{stroke-dasharray:132 134;stroke-dashoffset:133;animation:fCYXbxDN_draw 2980ms linear 10ms forwards;}.fCYXbxDN_2{stroke-dasharray:184 186;stroke-dashoffset:185;animation:fCYXbxDN_draw 2980ms linear 20ms forwards;}@keyframes fCYXbxDN_draw{100%{stroke-dashoffset:0;}}@keyframes fCYXbxDN_fade{0%{stroke-opacity:1;}94.44444444444444%{stroke-opacity:1;}100%{stroke-opacity:0;}}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundoff);
export default __webpack_public_path__ + "static/media/soundoff.c293c80684bd9595ae9b587aeebec0ad.svg";
export { ForwardRef as ReactComponent };